import admin from './admin'
import regularUser from './regular-user'

const accessControlDefinitions = {
  "REGULAR_USER": regularUser,
  "ADMIN": admin
}

export default accessControlDefinitions